import React from 'react';

import { type MenuSkeletonItemProps } from '../../../types';

import { MenuSkeletonItem } from './MenuSkeletonItem';

export const SkeletonItem = (props: MenuSkeletonItemProps): React.JSX.Element => {
	return <MenuSkeletonItem {...props} />;
};
